
import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import { UserMemberTypeEnum } from '@xt/client/enums'
import type { CommentItem, BaseCommentInfo } from '@xt/client/entities/course-v2/comments'

@Observer
@Component({
  components: { HeaderImage }
})
export default class ContentCommentUI extends Vue {
  // 评论列表
  @Prop({ required: true }) list: Array<CommentItem<number | string>>

  // 当前数据是否在加载
  @Prop({ required: true }) loading: boolean

  // 是否还有更多的一级“评论”
  @Prop({ required: true }) rootHasMore: boolean

  // 是否展示喜欢按钮
  @Prop({ required: true }) showLike: boolean

  // 是否展示回复按钮
  @Prop({ required: true }) showReply: boolean

  // 当前的内容主体是否属于自己
  @Prop({ required: true }) selfContent: boolean

  // 当前登录用户的id
  @Prop({ required: true }) selfMemberId: string

  // 当前内容主体的id
  @Prop({ required: true }) contentMemberId: string

  get UserStore() {
    return this.$store.$storeUser.UserInfo
  }

  checkIsAuthor(comment: BaseCommentInfo<number | string>) {
    return comment.memberId === this.contentMemberId
  }

  getShowMoreAction(comment: BaseCommentInfo<number | string>) {
    /**
     * 规则
     *
     * 1. 如果当前内容不是自己的 仅允许自己删除自己发送的评论
     * 2. 如果当前内容是自己的 则允许删除其他人的评论（除助教评论外）
     */

    if (this.selfContent) {
      return comment.memberType !== UserMemberTypeEnum.TeachingAssistant
    } else {
      return comment.memberId === this.selfMemberId
    }
  }

  handleClickReply(commentId: string | number, rootCommentId: string | number, toMemberId: string, toMemberNickname: string) {
    if (!this.UserStore.id) {
      this.$emit('unauthorized')
      return
    }

    this.$emit('reply-comment', {
      commentId,
      rootCommentId,
      toMemberId,
      toMemberNickname
    })
  }

  handleRemove(commentId: string | number, rootCommentId: string | number) {
    this.$emit('remove', { commentId, rootCommentId })
  }

  handleLike(comment: BaseCommentInfo<number | string>, commentId: string | number, rootCommentId: string | number) {
    if (!this.UserStore.id) {
      this.$emit('unauthorized')
      return
    }

    if (comment.like === true) {
      this.$message.error('你已经点过赞了')
      return
    }

    this.$emit('like-comment', { commentId, rootCommentId })
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
